<template>
  <div class="gxh">
    <div class="gxh-title">
      <div>个性化定制平台-EIP</div>
      <p>量身定制，专属服务</p>
    </div>
    <div class="gxh-content">
      <p class="content-title">
        EIP(Enterprise Information
        Portal)产品是建立在大规模数据库集群基础上，完全依照客户的信息需求特性，量身定制的信息服务产品，界面亦采用资讯网站形式为主，并能够配合Intranet信息投放、Email、光媒介、纸媒介等其他接口形式。
      </p>
      <div class="content-wrap">
        <img class="wrap-img" src="@/assets/image/gw_gxh.png" />
        <div class="wrap-info">
          <div class="info-item">
            <div class="item-til">
              <div></div>
              个性化信息服务
            </div>
            <p class="item-ind">完全依照客户的信息需求特性，量身定制的信息服务产品。</p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              完美的表现形式
            </div>
            <p class="item-ind">以门户网站和内容检索引擎为表现形式，方便易用。</p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              专业的信息需求分析
            </div>
            <p class="item-ind">
              产品的构架、功能及内容将全部依据用户的需求进行设计。设计初期将与客户针对需求进行反复分析论证和试验，得到客户需求的信息定义，并加载到ROBOT抓取程序中，进入数据库集群的底层原料库进行抓取，用户使用中系统不断进行热度统计，修正初期的信息定义，以达到完全贴近客户的需求。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              丰富的信息来源
            </div>
            <p class="item-ind">拥有上千种信息源，还可根据不同客户的需求而增录所需的专业媒体。</p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              精准的信息收集
            </div>
            <p class="item-ind">
              通过系统自动处理和人工干预，对信息进行准确分类，实现有效信息的最大集合，摒弃垃圾信息的干扰。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              高度的可扩展性
            </div>
            <p class="item-ind">能适应用户新的需求调整的变化，满足用户业务调整和扩展的要求。</p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              完善的售后服务
            </div>
            <p class="item-ind">专业的客户服务团队，为客户提供专业高效的客户服务。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../styles/global.less';
.gxh-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 536px;
  background: url(~@/assets/image/back_diy.png) center no-repeat;
  background-size: 100% 100%;
  div {
    margin: 48px 0;
    font-size: 48px;
    font-weight: 600;
    color: #ffffff;
  }
  p {
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
  }
}
.gxh-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: 64px auto;
  .content-title {
    margin: 0 0 64px;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .content-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    .wrap-img {
      max-width: 50%;
    }
    .wrap-info {
      width: 45%;
      .info-item {
        padding: 24px 40px;
        margin: 32px 0;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 0px 16px 0px #cfd8eb;
        .item-til {
          position: relative;
          font-size: 24px;
          font-weight: 600;
          color: #333333;
          div {
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 50px;
            height: 20px;
            opacity: 0.3;
            background: #0377ff;
            border-radius: 10px;
          }
        }
        .item-ind {
          margin: 24px 0;
          font-size: 16px;
          font-weight: 400;
          color: #656565;
        }
      }
    }
  }
}
</style>
